import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CadensSharedModule } from '../../shared';
import { CadensAdminModule } from '../../admin/admin.module';
import { LegalComponent } from './legal.component';

import {
    legalRoute
} from './';

let ENTITY_STATES = [
    ...legalRoute
];

@NgModule({
    imports: [
        CadensSharedModule,
        CadensAdminModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        LegalComponent
    ],
    entryComponents: [
        LegalComponent
    ],
    providers: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CadensLegalModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/legal/legal.module.ts